import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.oversized-text-cta' ).each( function( index, component ) {
        const splide = new Splide( $( component ).find( '.splide--oversized-text-cta' )[0], {
          type: 'loop',
          pagination: false,
          arrows: false,
          gap: '0px',
          autoWidth: true,
          pauseOnHover: true,
          drag: false,
          autoScroll: {
            speed: 1,
          },
        } );

        splide.mount( {AutoScroll} );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'oversized-text-cta', COMPONENT );
} )( app );
